<template>
  <tr class="wa-row" :class="{ 'wa-row--active': isActive, 'wa-row--inactive': !isActive }">
    <td class="wa-cell wa-cell--check" @click.stop>
      <Checkbox :value="selected" @input="emitSelect" />
    </td>

    <td class="wa-cell wa-cell--area">
      <span class="wa-area-name" dir="auto" :title="workingArea.area_name">{{ workingArea.area_name }}</span>
    </td>

    <td class="wa-cell wa-cell--status">
      <span class="wa-status-pill" :class="isActive ? 'wa-status-pill--on' : 'wa-status-pill--off'">
        {{ isActive ? $t('active') : $t('inactive') }}
      </span>
    </td>

    <td class="wa-cell wa-cell--rooms">
      <button
        type="button"
        class="wa-link-btn"
        :disabled="!workingArea.rooms_number"
        @click="openListModal('rooms')"
      >
        {{ workingArea.rooms_number }}
      </button>
    </td>

    <td class="wa-cell">
      <button
        v-if="workingArea.shifts && workingArea.shifts.length"
        type="button"
        class="wa-shifts-btn"
        @click="openListModal('shifts')"
      >
        <span class="wa-shifts-text" dir="auto">{{ shiftsPreview }}</span>
        <span v-if="hiddenShiftsCount" class="wa-shifts-more">+{{ hiddenShiftsCount }}</span>
      </button>
      <span v-else class="wa-muted">—</span>
    </td>

    <td class="wa-cell">
      <WorkingAreaAlertFlags :working-area="workingArea" />
    </td>

    <td v-if="isAdmin" class="wa-cell wa-cell--actions">
      <button type="button" class="wa-icon-btn" :title="$t('edit')" @click="emitEdit">
        <img src="@/assets/survey/edit-selected.svg" alt="" />
      </button>
      <button type="button" class="wa-icon-btn wa-icon-btn--danger" :title="$t('remove')" @click="emitRemove">
        <img src="@/assets/delete-icon.svg" alt="" />
      </button>
    </td>
  </tr>
</template>

<script>
import Checkbox from '@/modules/common/components/Checkbox'
import WorkingAreaAlertFlags from './WorkingAreaAlertFlags.vue'
import { isWorkingAreaActive } from '../utils/workingAreaStatus'

const SHIFTS_PREVIEW_MAX = 2

export default {
  props: {
    workingArea: {
      type: Object,
      required: true,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isActive() {
      return isWorkingAreaActive(this.workingArea)
    },
    shiftsPreview() {
      const shifts = this.workingArea.shifts || []
      if (!shifts.length) return ''
      return shifts.slice(0, SHIFTS_PREVIEW_MAX).join(', ')
    },
    hiddenShiftsCount() {
      const shifts = this.workingArea.shifts || []
      return shifts.length > SHIFTS_PREVIEW_MAX ? shifts.length - SHIFTS_PREVIEW_MAX : 0
    },
  },
  methods: {
    openListModal(type) {
      const items = type === 'rooms'
        ? (this.workingArea.rooms_names || [])
        : (this.workingArea.shifts || [])
      this.$emit('openListModal', {
        type,
        titleKey: type === 'rooms' ? 'rooms' : 'shifts',
        subtitle: this.workingArea.area_name,
        items,
      })
    },
    emitSelect(value) {
      this.$emit('select', this.workingArea.id, !!value)
    },
    emitEdit() {
      this.$emit('editWorkingArea', this.workingArea.id)
    },
    emitRemove() {
      this.$emit('removeWorkingArea', this.workingArea.id)
    },
  },
  components: {
    Checkbox,
    WorkingAreaAlertFlags,
  },
}
</script>
